<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    @change="setCollectorId"
    :label="$t('collectors')"
    item-text="name"
    item-value="id"
    prepend-icon="mdi-account-cash light-green--text"
    dense
    filled
    hide-details
    solo-inverted
    clearable
  ></v-autocomplete>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-collectors",
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
    endpoint: "",
    level: "",
  }),
  async created() {
    // ====================================================
    // 1. Config Endpoint:
    this.level = localStorage.getItem("level");

    if (this.level == "collaborator") {
      this.level = "colab";
    }

    this.endpoint = `${this.level}/collectors/list`;

    // ====================================================
    // 2. Request If Level Regional Manager
    if (this.level == "regionalManager") {
      this.getCollectorsList();
    }
  },
  computed: {
    enableAutocompleteRegionals() {
      return this.$store.state.filters.autocompleteRegionals.enable;
    },
    enableAutocompleteCollectors() {
      return this.$store.state.filters.autocompleteCollectors.enable;
    },
    // ====================================================
    // 2. IF - Administrator (Setup Id Regional)
    id_regional() {
      if (this.level == "administrator" || this.level == "collaborator") {
        return this.$store.state.filters.autocompleteRegionals.id;
      }
      return null;
    },
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;
      // Items have already been requested
      if (this.isLoading) return;
      // Request
      this.getCollectorsList();
    },
    // ====================================================
    // 3. IF - Administrator
    id_regional(val) {
      if (this.enableAutocompleteCollectors) {
        val && this.getCollectorsList();
      }
    },
    // Observar a "troca de rota" ou o array de "items",
    // e se caso existir o id_local na url (query ou params),
    // filtrar o item, exibir no select e setCollectorId no store:
    items() {
      this.selectCollectorByQueryOrParams();
    },
    $route() {
      this.selectCollectorByQueryOrParams();
    },
  },
  methods: {
    setCollectorId(id) {
      this.$store.commit("setCollectorId", id ? id : "");
    },

    async getCollectorsList() {
      this.isLoading = true;
      try {
        const response = await this.$request.post(this.endpoint, {
          // if - administrator level follow:
          id_regional: this.id_regional,
        });
        if (response.length == 0) {
          this.items = [];
          return;
        }

        this.items = response.dados.map((item) => ({
          name: `${item.nome} (${item.id})`,
          id: item.id,
          id_regional: item.id_regional,
          login: item.login,
        }));
        this.$store.commit("listCollectors", this.items);
      } finally {
        this.isLoading = false;
      }
    },

    selectCollectorByQueryOrParams() {
      let select;

      if (this.$route.params.id_collector) {
        select = this.items.filter(
          (item) => item.id == this.$route.params.id_collector
        );
      }

      if (this.$route.query.id_collector) {
        select = this.items.filter(
          (item) => item.id == this.$route.query.id_collector
        );
      }

      if (!this.$route.query.id_collector && !this.$route.params.id_collector) {
        return;
      }

      console.log(select[0] == undefined);
      if (select[0] == undefined) return;
      this.select = select[0];
      this.setCollectorId(this.select.id);
    },
  },
};
</script>
